import { SignupForm } from "@/components/auth";
import { withErrorBoundary } from "@/components/hoc";
import React from "react";

const Signup: React.FC = () => {
    return <SignupForm />;
};

export default withErrorBoundary({ component: "Signup" })(Signup);
